import React, { Fragment } from 'react';
import './who-we -are.css'
const WhoWeAre = ({ content }) => (
  <Fragment>
    <div className="section pv5">
      <div className="container">
        <div className="row">
          <div className="col-md-12 margin">
            <p className="tc tx-color">{content.body}</p>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
)

export default WhoWeAre



// WEBPACK FOOTER //
// ./src/views/about/who-we-are.js